const getOgImageLink = (pageTitle) =>
  `https://og-image-j5av8lms1-remoteteam.vercel.app/` +
  `${encodeURIComponent(pageTitle)}.png?theme=dark` +
  `&fontSize=110px` +
  `&images=https://res.cloudinary.com/hebu10lmu/image/upload/c_scale,q_auto,w_510/v1613983867/logo-dark-blue_ftitle.png`;
// +`&images=https://res.cloudinary.com/hebu10lmu/image/upload/f_auto,w_700/v1613984008/world_k1upgj.png`;

module.exports = getOgImageLink;
